<div class="panel">
  <h1>{{ 'COMMUNICATION.TeamCom' | translate }}</h1>
  <h3>{{ 'COMMUNICATION.For' | translate }}</h3>
  <h3>{{ selectedProject.name }}</h3>
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <h4 style="text-align:left; color: red">{{'COMMUNICATION.Note' | translate}} :</h4>
        <h4 style="text-align:left; color: red">{{'COMMUNICATION.NoteText' | translate}}</h4>
      </div>
      <div class="col-sm-12">
        <div  style="margin-top: 2vh;">
          <label style="font-size: 15px;">{{'COMMUNICATION.PrimaveraDownNotification' | translate}}</label>
          <p-button (click)="confirmSendNotification()" [disabled]="!selectedProject.id" style="margin-top: 1vh;" styleClass="ui-button-primary" label="{{'COMMUNICATION.SendNotification' | translate}}"></p-button>
        </div>
      </div>
      <div class="col-sm-12">
        <div style="margin-top: 2vh;">
          <label style="font-size: 15px;">{{'COMMUNICATION.PrimaveraDownEmail' | translate}}</label>
          <p-button (click)="confirmSendEmail()" [disabled]="!selectedProject.id" style="margin-top: 1vh;" styleClass="ui-button-primary" label="{{'COMMUNICATION.SendEmail' | translate}}"></p-button>
        </div>
      </div>
      <div class="col-sm-12">
        <div  style="margin-top: 2vh;">
          <label style="font-size: 15px;">{{'COMMUNICATION.SendGroupNotification' | translate}}</label><br/>
          <p-button (click)="showDialog()" [disabled]="!selectedProject.id" style="margin-top: 1vh;" styleClass="ui-button-primary" label="{{'COMMUNICATION.SendGroupMessage' | translate}}"></p-button>
        </div>
      </div>
    </div>
    <p-dialog header="{{'COMMUNICATION.SendGroupMessage' | translate}}" [(visible)]="displayAddDialog" showEffect="fade"
    [modal]="true" styleClass="customDialog">
    <div  class="container">
      <div class="row">
        <div class="col-sm-4"><label for="text">{{'COMMUNICATION.SelectGroups' | translate}}</label></div>
        <div class="col-sm-8"><p-multiSelect [style]="{'width':'100%'}" [options]="groupList" [(ngModel)]="selectedGroupList" optionLabel="Crew.Description" appendTo="body" ></p-multiSelect></div>
      </div>
      <div class="row">
        <p></p>
      </div>
      <div class="row">
        <div class="col-sm-4"><label for="text">{{'COMMUNICATION.Message' | translate}}</label></div>
        <div class="col-sm-8"><textarea pInputTextarea style="width: 100%;" rows="5" id="messageTxt" [(ngModel)]="message" ></textarea></div>
      </div>
    </div>
    <ng-template #footer>
      <div class="ui-dialog-buttonpane ui-helper-clearfix">
        <button type="button" class="btn btn-primary" style="margin-right: 10px;"  icon="fa fa-close" (click)="closeDialog()">{{'COMMUNICATION.Cancel' | translate}}</button>
        <button type="button" class="btn btn-primary" icon="fa fa-check" (click)="sendGroupMessage()">{{'COMMUNICATION.Send' | translate}}</button>
      </div>
    </ng-template>
  </p-dialog>
  </div>
</div>
